import { useQuery } from '@tanstack/react-query';

import { Declaration } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useRetrieveFinalizeDeclarationsInfo = (id: string) =>
  useQuery({
    queryKey: ['retrieve-declaration-finalize', id],
    queryFn: async (): Promise<Declaration> => {
      try {
        const { declaration } = await request({
          path: `batches/${id}/retrieve-finalize-declarations-info`,
          method: 'GET',
          authenticate: true,
        });

        return declaration;
      } catch (error) {
        showErrorToast(error, 'Error fetching the finalize declarations info!');
      }
    },
    enabled: !!id,
  });
